import React, { useState, useEffect, useContext } from "react";
import LeftHome from "../components/Home/LeftHome";
import RightHome from "../components/Home/RightHome";
import CreatePost from "../components/Home/CreatePost";
import "../styles/home.css";
import "../styles/profile.css";
import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";
import "../styles/user.css";
import "../styles/profile.css"

import { UserContext } from "../context/UserContext";

const HomePage = () => {
  const handleCloseForm = (e) => {
    e.preventDefault();
    setCloseForm(!closeForm);
  };

  const defaultPost = {
    pic: "",
    requirements: "",
    tags: [],
    about: "",
    techStack: "",
    url: "",
    title: "",
  };

  const [post, setPost] = useState(defaultPost);
  const { user, setUser } = useContext(UserContext);
  const [closeForm, setCloseForm] = useState(true);

  return (
    <>
      <SlideDown closed={closeForm}>
        <div className="userForm">
          <span
            className="closeFormBtn"
            onClick={(e) => {
              e.preventDefault();
              setCloseForm(!closeForm);
            }}
          >
            X
          </span>

          <div className="form">
            <CreatePost
              post={post}
              setPost={setPost}
              setCloseForm={setCloseForm}
              closeForm={closeForm}
            />
          </div>
        </div>
      </SlideDown>

      {closeForm && (
        <div className="homeGrid">
          <LeftHome
            defaultPost={defaultPost}
            closeForm={closeForm}
            setCloseForm={setCloseForm}
          />
          <RightHome />
        </div>
      )}
    </>
  );
};

export default HomePage;
